import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const MobileApps = () => {
  const services = [
    'Native iOS Development',
    'Native Android Development',
    'Cross-Platform Solutions',
    'Mobile Backend Services',
    'App Store Optimization',
    'Maintenance & Support'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Mobile Application Development</h1>
          <p>
            Native and cross-platform mobile solutions for iOS and Android 
            with exceptional user experiences.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Overview</h2>
            <p>
              Mobile applications are critical touchpoints for customer engagement and business 
              operations. We develop high-performance mobile apps using native technologies 
              (Swift, Kotlin) and cross-platform frameworks (React Native, Flutter).
            </p>
            <p>
              Our mobile development process includes UX design, performance optimization, security 
              implementation, and app store submission to ensure successful launches and ongoing success.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Mobile Development Services</h2>
            <p>Complete mobile application development capabilities</p>
          </div>
          <div className="expertise-grid">
            {services.map((service, index) => (
              <div key={index} className="expertise-item">
                {service}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Launch Your Mobile App</h2>
            <p>Get started with a mobile strategy consultation and development roadmap.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MobileApps;
